import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FarmService } from 'src/app/services/farm-service.service';
import { Location } from "@angular/common";
import moment from 'moment';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { PhameeService } from 'src/app/services/phamee.service';

declare const $:any;

@Component({
  selector: 'smart-manage-farm-plot-edit',
  templateUrl: './manage-farm-plot-edit.component.html',
  styleUrls: ['./manage-farm-plot-edit.component.scss','../../platform-color/platform-color.css']
})
export class ManageFarmPlotEditComponent implements OnInit {
  form: FormGroup;
  submitted: boolean = false;

  image = null;
  selectFile = null;

  polygons: any[] = [];
  currentPolygons: any[] = [];

  AllPlot: any[] = [];
  allPolygon: any[] = [];

  zoom: number = 18;
  // initial center position for the map
  lat: number = 13.764913;
  lng: number = 100.538283;
  loadMap: boolean = false;
  loadPolygon: boolean = false;
  polygon: any;

  plotDetail = null;
  zoneDetail = null;

  id: string;
  name: string;
  plot_name: string;
  plot_id: string;

  tab: number = 2;
  successModal: string = '#successModal';
  errorModal: string = '#errorModal';
  deleteModal: string = '#deleteModal';
  successDelModal: string = '#successDelModal';
  imageURL: string;

  errorMessage: string = 'กรุณาลองใหม่อีกครั้ง';

  managerOptions = {
    drawingControl: true,
    drawingControlOptions: {
      drawingModes: ['polygon']
    },
    polygonOptions: {
      draggable: true,
      editable: true,
      fillColor: "black",
      strokeColor: "black",
      strokeWeight: "2"
    }
  };

  minEnddate: boolean = false;
  sizeFileOver: boolean = false;
  typeFileOver: boolean = false;
  confirmDeleteBtn: boolean = false;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private formBuilder: FormBuilder,
    private farmService: FarmService,
    private phameeService: PhameeService,
    private sanitizer: DomSanitizer,

    private cd: ChangeDetectorRef
  ) { 
    this.plot_name = this.route.snapshot.paramMap.get("plot_name");
    this.plot_id = this.route.snapshot.paramMap.get("plot_id");

    this.imageURL = environment.URLUPLOAD;
  }

  ngOnInit(): void {
    this.createForm();

    this.getPlotByname(this.plot_name);
  }

  createForm(){
    this.form = this.formBuilder.group({
      _id: [""],
      color: [""],
      farm_id: [""],
      zone_id: [""],
      name: ["", [Validators.required, Validators.pattern(/[\S]/g)]],
      area_size: ["", [Validators.required]],
      type: ["", [Validators.required]],
      start_date: ["", [Validators.required]],
      end_date: ["", [Validators.required]],
      desc: [""],
      video: ["",  [Validators.required]],
      camera_flag: [false],
      camera_id: [""],
      camera_object_id: [""],
    })
    this.valueChange();
  }

  valueChange(){
    this.form.controls.camera_flag.valueChanges.subscribe(
      (value) => {

        if(value){
          this.form.get('camera_id').setValidators([Validators.required]);
        }else{
          this.form.get('camera_id').setValue("");
          this.form.get('camera_id').setValidators(null);
        }
        this.form.get('camera_id').updateValueAndValidity();
      }
    );
  }

  get f() {
    return this.form.controls;
  }

  startDateChanged(event){
    this.minEnddate = event;
    if(moment(this.form.value.start_date).format() > moment(this.form.value.end_date).format()){
      this.form.get('end_date').setValue("");
    }
  }

  getPlotByname(plot_name){
    if(plot_name){
      this.farmService.getPlotByName(plot_name).subscribe(success => {
        if (success.code == 200) {

          this.plotDetail = success.data.find(plot=> plot._id == this.plot_id);

          this.getPlots(this.plotDetail.farm_id);

          this.lat = this.plotDetail.coordinates['center'].lat;
          this.lng = this.plotDetail.coordinates['center'].lon;
          this.zoom = this.plotDetail.coordinates['center'].zoom_lv;
          this.polygons = this.plotDetail.coordinates.map_polygon;
          
          if(this.plotDetail.picture && this.plotDetail.picture.length > 0){
            this.image = this.imageURL + this.plotDetail.picture[0].path;
          }

          if(this.plotDetail.zone_id){
            this.farmService.getZone(this.plotDetail.zone_id).subscribe(zone=>{

              this.zoneDetail =  zone.data[0];

              let data = {
                ...this.plotDetail,
                color: this.zoneDetail.color,
                area_size: this.zoneDetail.ares? 
                this.zoneDetail.ares.size: "",
                zone_id: this.zoneDetail._id,
                start_date: moment(this.plotDetail.start_date).format('DD/MM/YYYY'),
                end_date: moment(this.plotDetail.end_date).format('DD/MM/YYYY'),
                camera_id: this.plotDetail.camera? this.plotDetail.camera.camera_id: ""
              }
    
              this.managerOptions.polygonOptions.fillColor = this.zoneDetail.color;
              this.managerOptions.polygonOptions.strokeColor = this.zoneDetail.color;
              this.form.patchValue(data);

              this.loadMap = true;

              setTimeout(() => {
                this.reset();
              }, 1000);
            })
          }
        }
      });
    }
  }

  getPlots(farmId) {
    this.phameeService.getPlotDashboard(farmId)
      .subscribe(success => {
        if (success.code == 200) {
          this.AllPlot = success.data.plot.filter(plot=> plot.id != this.plot_id);

          this.reset();
        }
      });
  }  

  zoomChange(zoom_lv){
    this.zoom = zoom_lv;
  }

  mapReady(map) {
    map.setOptions({
      zoomControl: "true",
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM
      },
      draggable: true,
      editable: true,
      visible: true,
      controlSize: 30,
    });

    map.controls[google.maps.ControlPosition.TOP_LEFT].push(document.getElementById('delete'));

    let arr = this.plotDetail.coordinates.map_polygon
    let polygons = [];

    for (let j = 0; j < arr.length; j++) {
      const elementPolygon = arr[j];
      polygons.push(
        new google.maps.LatLng(elementPolygon.lat, elementPolygon.lon),
      )
    }

    this.currentPolygons = polygons;

    for (let i = 0; i < this.AllPlot.length; i++) {
      let polygons = [];
      const element = this.AllPlot[i];
      if(element.coordinates.map_polygon.length > 0){
        for (let j = 0; j < element.coordinates.map_polygon.length; j++) {
          const elementPolygon = element.coordinates.map_polygon[j];

          polygons.push(
            new google.maps.LatLng(elementPolygon.lat, elementPolygon.lon),
          )
        }
      }
        
      this.allPolygon.push(
        { polygons: polygons, color: element.zone.color || 'red' }
      )
    }

    this.loadPolygon = true;


    this.reset();
  }

  currentPolygonChangeEvent($event){
    let me = $event;

    let arr = me.newArr[0];

    this.polygons = [];
    
    for (let i = 0; i < arr.length; i++) {
      this.polygons.push(
        {
          "seq": i+1,
          "lat": arr[i].lat,
          "lon": arr[i].lng
        }
      )
    }

    var area = google.maps.geometry.spherical.computeArea(arr);

    this.form.get('area_size').setValue(area.toFixed(2));

    this.reset();
  }

  delPolygon(){
    this.currentPolygons = [];
    if (this.polygon) {
      this.polygon.setMap(null);
    }

    this.polygons = [];
  }

  polygonCreated($event) {
    if (this.polygon) {
      this.polygon.setMap(null);
    }
    this.polygon = $event;
    this.addPolygonChangeEvent(this.polygon);
    this.currentPolygons = [];

    var area = google.maps.geometry.spherical.computeArea(this.polygon.getPath());

    this.form.get('area_size').setValue(area.toFixed(2));

    google.maps.event.addListener(this.polygon, 'coordinates_changed', function (index, obj) {
      console.log('coordinates_changed');
    });
  }

  addPolygonChangeEvent(polygon) {
    var me = polygon,
    isBeingDragged = false,
    triggerCoordinatesChanged = function () {
      google.maps.event.trigger(me, 'coordinates_changed');
    };

    google.maps.event.addListener(me, 'dragstart', function () {
      isBeingDragged = true;
    });

    google.maps.event.addListener(me, 'dragend', function () {
      triggerCoordinatesChanged();
      isBeingDragged = false;
    });

    var paths = me.getPaths();
    this.polygons = [];

    var numberOfPath = polygon.getPath().getLength();
  
    for (let i = 0; i < numberOfPath; i++) {

      var vertex = polygon.getPath().getAt(i);

      this.polygons.push(
        {
          "seq": i+1,
          "lat": vertex.lat(),
          "lon": vertex.lng()
        }
      );
    }

    this.reset();

    paths.forEach(function (path, i) {
      google.maps.event.addListener(path, "insert_at", function () {
        triggerCoordinatesChanged();
      });
      google.maps.event.addListener(path, "set_at", function () {
        if (!isBeingDragged) {
          triggerCoordinatesChanged();
        }
      });
      google.maps.event.addListener(path, "remove_at", function () {
        triggerCoordinatesChanged();
      });
    });
  };

  reset(){
    this.cd.detectChanges();
  }

  save(){

    this.submitted = true;
    if(
      this.form.invalid || 
      (!this.isVideo(this.form.value.video) && this.form.value.video) ||
      !this.image ||
      this.sizeFileOver ||
      this.typeFileOver
    ){
      return;
    }

    if(this.form.value.camera_flag && !this.form.value.camera_object_id){
      let camera = {
        plot_id: this.form.value._id,
        camera_id: this.form.value.camera_id
      }
      this.farmService.createRealTimeCamera(camera).subscribe(camera=>{
        this.form.get("camera_object_id").setValue(camera.data._id);
        this.updatePlot(true);
      })
    }else{
      this.updatePlot();
    }
  }

  async updatePlot(flag = false){
    let zone = {
      zone_id:this.zoneDetail._id,
      farm_id: this.form.value.farm_id,
      org_id: sessionStorage.getItem('Org'),
      child_org_id: sessionStorage.getItem('ChildOrg'),
      name: this.form.value.name,
      desc: this.form.value.desc,
      ares: {
        size: this.form.value.area_size.toString(),
        unit: 'ตารางเมตร'
      },
      active: true,
      background_img: null,
      icon: null,
      color: this.form.value.color,
      coordinates: {
          center: {
              lat: this.lat,
              lon: this.lng,
              zoom_lv: this.zoom
          },
          map_polygon: this.polygons
      } 
    }
 
    let plot = new FormData();
    plot.append("plot_id", this.form.value._id);
    plot.append("org_id", sessionStorage.getItem('Org'));
    plot.append("child_org_id", sessionStorage.getItem('ChildOrg'));
    plot.append("name", this.form.value.name);
    plot.append("desc", this.form.value.desc);
    plot.append("type", this.form.value.type);
    plot.append("farm_id", this.form.value.farm_id);
    plot.append("video", this.form.value.video);
    plot.append("start_date", this.dateFormat(this.form.value.start_date));
    plot.append("end_date", this.dateFormat(this.form.value.end_date));
    plot.append("coordinates", JSON.stringify(zone.coordinates));
    plot.append("zone_id", this.form.value.zone_id);
    plot.append("camera_flag", this.form.value.camera_flag);

    if(this.form.value.camera_object_id){
      plot.append("camera_object_id", this.form.value.camera_object_id);
    }

    plot.append("status", "on_rest");

    if(this.selectFile){
      plot.append("picture", this.selectFile);
    }
    plot.append("active", JSON.stringify(true));

    this.farmService.updateZone(zone).subscribe(zone=>{
      if(zone.code == 200){
        this.farmService.updateNewPlot(plot).subscribe(async plot=>{
          if(plot.code == 200){
            if(this.form.value.camera_object_id && flag == false){
              let camera = {
                _id: this.form.value.camera_object_id,
                plot_id: this.form.value._id,
                camera_id: this.form.value.camera_id
              }
              this.farmService.updateRealTimeCamera(camera).subscribe(camera=>{
                this.getPlotMenu();
              })
            }else{
              this.getPlotMenu();
            }
          }else{
            if(plot.message == 'Data existed'){
              this.errorMessage = 'ชื่อแปลงของท่านมีอยู่แล้ว กรุณาลองใหม่อีกครั้ง';
    
              this.reset();
              $(`${this.errorModal}`).modal("show");
            }else{
              this.errorMessage = 'กรุณาลองใหม่อีกครั้ง';
    
              this.reset();
              $(`${this.errorModal}`).modal("show");
            }
          }
        })
      }else{
        this.errorMessage = 'กรุณาลองใหม่อีกครั้ง';
    
        this.reset();
        $(`${this.errorModal}`).modal("show");
      }
    })
  }

  async getPlotMenu(){
    await this.phameeService.getPlotMenu(sessionStorage.getItem('ChildOrg'))
    .subscribe(response => {
      let arrMenu = [];
      if (response.code == 200) {
        arrMenu = response.data    
        sessionStorage.setItem("menufarm", JSON.stringify(arrMenu));

        $(`${this.successModal}`).modal("show");
      }
  });
  }

  async getMenu(){
    await this.phameeService.getPlotMenu(sessionStorage.getItem('ChildOrg'))
    .subscribe(response => {
      let arrMenu = [];
      if (response.code == 200) {
        arrMenu = response.data;
        sessionStorage.setItem("menufarm", JSON.stringify(arrMenu));
        this.router.navigate(["/manage-farm"]).then(() => {
          window.location.reload();
        });
      }
    });
  }

  delete(){
    $(`${this.deleteModal}`).modal("show");
  }

  delPlot(){
    this.farmService.deletePlot(this.form.value._id).subscribe(async res=>{
      this.farmService.deleteZone(this.form.value.zone_id).subscribe(zone=>{
        $(`${this.deleteModal}`).modal("hide");

        $(`${this.successDelModal}`).modal("show");
      });
    })
  }

  dateFormat(date) {
    var datenow = new Date(date);
    if(moment(datenow, 'YYYY-MM-DD HH:mm:ss', true).isValid()){
      return moment.utc(datenow, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY');
    }else{
      return date;
    }
  }

  back(): void {
    this.router.navigate(["/manage-farm"]).then(() => {
      window.location.reload();
    });
  }

  isVideo(url: string): boolean {
    const videoExtensions = ['.mp4', '.webm', '.ogg', '.3gp'];
    return videoExtensions.some(ext => url.endsWith(ext));
  }

  uploadImage(){
    document.getElementById("image_file").click();
  }

  onFileChange(file){

    this.selectFile = <File>file[0];

    var mimeType = this.selectFile.type;
    var size = this.selectFile.size;

    if(size >= 100000000){
      this.sizeFileOver = true;
    }else{
      this.sizeFileOver = false;
    }

    if(mimeType.includes("jpeg")){
      this.typeFileOver = false;
    }else{
      this.typeFileOver = true;
    }

    var reader = new FileReader();      
    reader.readAsDataURL(this.selectFile); 
    reader.onload = (_event) => { 
      this.image = reader.result; 

      this.reset();
    }
  }

  deleteFile(){
    this.image = null;
  }
}
